export const TopMenu = [
  {
    label: "footer.RunANode",
    link: "https://node.ont.io/app/node-running",
    target: "_blank"
  },
  {
    label: "footer.StakeOnt",
    link: "https://node.ont.io/app/node-stake"
  },
  {
    label: "footer.stONT",
    link: "https://node.ont.io/liquid-staking"
  },
  {
    label: "footer.Calculator",
    link: "/calculator/node"
  },
  {
    label: "footer.Docs",
    link: "https://node-docs.ont.io"
  }
]
export const FooterMenu = [
  {
    label: "footer.About",
    children: [
      {
        label: 'footer.aboutUs',
        link: 'https://ont.io/about'
      },
      {
        label: 'footer.joinUs',
        link: 'https://ont.io/join'
      },
      {
        label: 'footer.Branding',
        link: 'https://ont.io/branding'
      },
      {
        label: 'footer.Partners',
        link: 'https://ont.io/partners'
      },
      {
        label: 'footer.ContactUs',
        link: 'https://ont.io/contact'
      }
    ]
  },
  {
    label: "footer.useOntology",
    children: [
      {
        label: 'footer.OntOng',
        link: 'https://ont.io/tokens'
      },
      {
        label: 'footer.Bridge',
        link: 'https://bridge.ont.io/'
      },
      {
        label: 'footer.Explorer',
        link: 'https://explorer.ont.io'
      },
      {
        label: 'footer.Nodes',
        link: 'https://node.ont.io'
      },
      {
        label: 'footer.OWallet',
        link: 'https://github.com/ontio/OWallet'
      },
      {
        label: 'footer.ONTO',
        link: 'https://onto.app/'
      }
    ]
  },
  {
    label: "footer.Developers",
    children: [
      {
        label: 'footer.DeveloperCenter',
        link: 'https://docs.ont.io/'
      },
      {
        label: 'footer.CommunityForm',
        link: 'https://buidl.ont.io/'
      },
      {
        label: 'footer.Github',
        link: 'https://github.com/ontio'
      },
      {
        label: 'footer.Discord',
        link: 'https://discord.com/invite/4SrrJy2zHe'
      },
      {
        label: 'footer.GetTestnetTokens',
        link: 'https://ont.io/faucet'
      }
    ]
  }
]
export const FooterIcon = [
  {
    link: 'https://twitter.com/OntologyNetwork',
    src: require('assets/img/footer/twitter@2x.png'),
  },
  {
    link: 'https://twitter.com/OntologyJP',
    src: require('assets/img/footer/twitterJP@2x.png')
  },
  {
    link: 'https://www.facebook.com/ONTnetwork/',
    src: require('assets/img/footer/facebook@2x.png')
  },
  {
    link: 'https://www.linkedin.com/company/ontology-network-official/',
    src: require('assets/img/footer/linkedin@2x.png')
  },
  {
    link: 'https://medium.com/ontologynetwork',
    src: require('assets/img/footer/medium@2x.png')
  },
  {
    link: 'https://t.me/OntologyAnnouncements',
    src: require('assets/img/footer/telegram@2x.png')
  },
  {
    link: 'https://www.reddit.com/r/OntologyNetwork/',
    src: require('assets/img/footer/reddit@2x.png')
  },
  {
    link: 'https://www.youtube.com/channel/UCXzLZJgDglAWRU0b2GOa7pA',
    src: require('assets/img/footer/youtube.png')
  },
  {
    link: 'https://discord.com/invite/4SrrJy2zHe',
    src: require('assets/img/footer/discord@2x.png')
  },
  {
    link: 'https://github.com/ontio',
    src: require('assets/img/footer/github@2x.png')
  }
]